import React, { useEffect, useState } from 'react'
import { Query } from "../../../utilities/incognitaAPI"
import Table from 'UI/Table'
import { Alert, Button } from 'react-bootstrap'
import { GET_MONITORING_TYPES } from './queries'
import DeletePopup from './DeletePopup'
import useColumns from './useColumns'
import Form from './Form/index'
import { isObject } from 'lodash'
import PropTypes from 'prop-types'

const MonitoringTypes = () => {
  const [alert, setAlert] = useState({})
  const [loading, setLoading] = useState(true)
  const [monitoringTypes, setMonitoringTypes] = useState([])
  const [monitoringTypeToRemove, setMonitoringTypeToRemove] = useState(undefined)
  const [monitoringTypeForm, setMonitoringTypeForm] = useState(undefined)

  const getMonitoringTypes = () => {
    setLoading(true)

    Query(GET_MONITORING_TYPES)
      .then(res => {
        setMonitoringTypes(res.logicmonitorMonitoringTypes)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    // Return when form is open
    if (isObject(monitoringTypeForm)) return

    getMonitoringTypes()
  }, [monitoringTypeForm])

  const columns = useColumns({
    onUpdate: setMonitoringTypeForm,
    onRemove: setMonitoringTypeToRemove
  })

  return (
    <div>
      <DeletePopup
        monitoringType={monitoringTypeToRemove}
        setMonitoringType={setMonitoringTypeToRemove}
        getMonitoringTypes={getMonitoringTypes}
        setAlert={setAlert}
      />

      <div className="flex justify-end">
        <Button onClick={() => setMonitoringTypeForm({})}>Create</Button>
      </div>
    
      {alert.text && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({})}
        >
          {alert.text}
        </Alert>
      )}

      <Form
        object={monitoringTypeForm}
        setObject={setMonitoringTypeForm}
      />

      <Table
        className="mt-10"
        columns={columns}
        data={monitoringTypes}
        loading={loading}
        tableProps={
          { defaultSorted: [{ id: 'monitoringType' }] }
        }
      />
    </div>
  )
}

Table.propTypes = {
  tableProps: PropTypes.object.isRequired
}

export default MonitoringTypes
